<template>
  <div class="text-wrapper">
    <div style="margin-bottom: 10px">
      标题: <el-input v-model="tableInfo.query.title" style="width: 200px" size="small" placeholder="请输入标题"></el-input>
      <el-button size="small" type="primary" style="margin: 0 10px 0 30px" @click="getList(1)">查询</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>
    <el-radio-group v-model="tableInfo.query.type" size="small" @change="getList(1)">
      <el-radio-button v-for="item in tabList" :key="item.id" :label="item.id">{{item.label}}</el-radio-button>
    </el-radio-group>
    <br />
    <el-button size="small" type="primary" style="margin-top: 10px" @click="openDia">新建</el-button>
    <div v-if="[4,5].includes(tableInfo.query.type)" class="table">
      <el-table
        :data="informationList"
        style="width: 100%"
        :border="true"
        row-key="id"
      >
        <el-table-column
          v-for="item in column"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width || '100'"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'infoName'">
              <a href="javascript:;" @click="openDetail(scope.row)">{{ scope.row.infoName }}</a>
            </template>
            <template v-else-if="item.prop === 'linkUrl'">
              <span v-if="scope.row.status === 1">
                {{ `${domainUrl}/talentServiceDetail?reLabel=相关政策及下载&rePath=/talentService?id=${scope.row.type}&id=${scope.row.id}` }}
              </span>
            </template>
            <template v-else-if="item.prop === 'infoImg' && scope.row.infoImg">
              <img
                class="table-img"
                :src="scope.row.infoImg"
                alt="资讯封面"
                @click="lookBigImg(scope.row)"
              />
            </template>
            <template v-else-if="item.prop !== 'infoImg'">
              {{ tableTranslation(item.prop, scope.row) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          key="option"
          prop="option"
          label="操作"
          align="center"
          min-width="180"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status === 1"
              @click="handleCancelTop(scope.row)"
            >
              {{ scope.row.topFlag === 2 ? '取消置顶' : '置顶' }}
            </el-button>
            <el-button type="text" @click="handleStatus(scope.row)">
              {{ scope.row.status === 1 ? '下架' : '发布' }}
            </el-button>
            <el-button type="text" @click="handleEditor(scope.row)">
              编辑
            </el-button>
            <el-button
              v-if="scope.row.status === 2"
              type="text"
              @click="delTalentServe(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="information-pagination">
        <el-pagination
          @size-change="handleLimitChange"
          @current-change="handlePageChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <div v-else class="table">
      <talent-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="true"
        :tab-index="true"
        :api="getTalentList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <template v-slot:col-title="scope">
          <div style="overflow-y: scroll;" v-html="scope.row.title"></div>
        </template>
        <template v-slot:col-status="scope">
          {{scope.row.status === 1 ? '已启用' : '已停用'}}
        </template>
        <template v-slot:bt-status="scope">
          <el-button @click="updateTalentServeType(scope.data.row)" type="text">{{scope.data.row.status === 1 ? '停用' : '启用'}}</el-button>
        </template>
        <template v-slot:bt-del="scope">
          <el-button @click="delTalentServe(scope.data.row)" type="text">删除</el-button>
        </template>
      </talent-table>
    </div>
    <talent-dialog
      ref="talentDialog"
      :dialog-visible="dialogVisible"
      @close="handleCloseDialog"
      @submit="onSubmit">
    </talent-dialog>
    <WriteDialog
      v-if="writeDialogFlag"
      :dialogTitle="writeDialogTitle"
      :handleClose="handleCloseWriteDialog"
      :close="close"
      :defaultData="writeDialogData"
      :typeId="tableInfo.query.type"
    />
    <PublicShowImg ref="showImgRef" />
  </div>
</template>
<script>
import talentTable from '@/components/PublicTable';
import talentDialog from './components/talentDialog';
import WriteDialog from './writeDialog.vue'
import PublicShowImg from '@/views/swiperManage/openImg.vue'
import { column2 } from '@/views/veteranManage/assets.js'
import { getTalentList, updateTalentServe, updateTalentServeType, addTalentServe, delTalentServe, talentupdateTopFlag } from '@/api/api'
export default {
  components: {
    talentTable,
    talentDialog,
    WriteDialog,
    PublicShowImg
  },
  data() {
    return {
      getTalentList,
      dialogVisible: false,
      tabList: [
        {
          id: 1,
          label: '劳务派遣'
        },
        {
          id: 5,
          label: '职业技能等级认定'
        },
        {
          id: 3,
          label: '招聘服务'
        },
        {
          id: 4,
          label: '相关政策及下载'
        }
      ],
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {
          type: 1,
          title: ''
        },
        fieldList: [
          // { label: '分页名称', value: 'name', width: '150px'},
          { label: '标题', value: 'title', type: 'slot' },
          { label: '状态', value: 'status', width: '100px', type: 'slot' },
          { label: '操作人', value: 'insertName', width: '100px' }
        ],
        handle: {
          label: '操作',
          width: '150px',
          btList: [
            { label: '编辑', type: 'text', event: 'edit', show: true },
            { label: '启用', type: 'text', event: 'status', show: true, slot: true },
            { label: '删除', type: 'text', event: 'del', show: true, slot: true },
          ]
        }
      },
      column: column2,
      limit: 10,
      page: 1,
      total: 0,
      informationList: [],
      writeDialogFlag: false,
      writeDialogTitle: '',
      writeDialogData: {},
    }
  },
  computed: {
    domainUrl () {
      if (process.env.VUE_APP_CURRENTMODE === 'prod') {
        return 'https://www.nrtatalent.cn'
      }
      return 'http://tvpc.shenlakaoyan.com'
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    // 提交表单
    onSubmit(form) {
      const params = {
        type: this.tableInfo.query.type,
        ...form
      }
      if (form.id) {
        updateTalentServe(params).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.handleCloseDialog();
            this.getList();
            this.$message.success('编辑成功');
          } else {
            this.$message.error(message);
          }
        })
      } else {
        addTalentServe(params).then(res => {
          this.$message.success('操作成功');
          this.handleCloseDialog();
          this.getList();
        })
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false;
    },
    reset () {
      this.tableInfo.query.title = ''
      if ([4,5].includes(this.tableInfo.query.type)) {
        this.limit = 10
        this.page = 1
        this.total = 0
        this.informationList = []
        this.getList()
      } else {
        this.getList()
      }
    },
    async updateTalentServeType(row) {
      const { code, message } = await updateTalentServeType({ id: row.id, status: row.status === 1 ? 2 : 1 })
      if (code === 0) {
        this.$message.success('操作成功')
        this.getList()
      } else {
        this.$message.error(message)
      }
    },
    delTalentServe(row) {
      this.$confirm('此操作将永久删除这条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delTalentServe({ id: row.id })
        this.$message.success('操作成功')
        this.getList()
      }).catch(() => {});
    },
    // 通过随机数请求列表
    getList(page = false) {
      if ([4,5].includes(this.tableInfo.query.type)) {
        const params = {
          ...this.tableInfo.query,
          limit: this.limit,
          page: page || 1
        }
        getTalentList(params).then(({ code, data }) => {
          if (code === 0) {
            this.informationList = data.records.map((item, ind) => ({
            ...item,
            index: (params.page - 1) * this.limit + ind + 1
          }))
            this.total = +data.total
          }
        })
      } else {
        this.tableInfo.refresh = Math.random();
      }
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getList()
    },
    // table操作
    handleClick(event, row) {
      if (event === 'edit') {
        this.dialogVisible = true;
        this.$refs.talentDialog.init(row);
      }
    },
    openDia() {
      if ([4,5].includes(this.tableInfo.query.type)) {
        this.writeDialogTitle = '新建资讯'
        this.writeDialogData = {}
        this.writeDialogFlag = true
      } else {
        this.dialogVisible = true;
        this.$refs.talentDialog.init({
          title: '',
          content: ''
        });
      }
    },
    handleEditor (row) {
      this.writeDialogTitle = '编辑资讯'
      this.writeDialogData = row
      this.writeDialogFlag = true
    },
    // 单元格点击查看封面大图
    lookBigImg(row) {
      const { infoImg, infoName } = row
      this.$refs.showImgRef.show(infoImg, infoName)
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
    // 表格单元格转换
    tableTranslation(key, row) {
      switch (key) {
        case 'status':
          switch (row[key]) {
            case 1:
              return '已上架'
            case 2:
              return '已下架'
            default:
              return ''
          }
        case 'topFlag':
          if (row['status'] === 1) {
            switch (row[key]) {
              case 1:
                return '未置顶'
              case 2:
                return '已置顶'
              default:
                return ''
            }
          } else {
            return '-'
          }
        case 'attachFlag':
          switch (row[key]) {
            case 0:
              return '否'
            case 1:
              return '是'
            default:
              return ''
          }
        default:
          return row[key]
      }
    },
    // 新建、编辑资讯弹框关闭
    handleCloseWriteDialog(bool, infoTitle) {
      if (infoTitle && infoTitle !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.close(bool)
        }).catch(() => {});
      } else {
        this.close(bool)
      }
    },
    close(bool) {
      this.writeDialogFlag = false
      switch (bool) {
        case 'reset':
          this.getList(1)
          break
        case 'update':
          this.getList()
          break
        default:
          break
      }
    },
    // 表格操作项点击取消置顶
    async handleCancelTop({ id }) {
      try {
        const { code } = await talentupdateTopFlag({ id })
        if (code === 0) {
          this.getList()
        }
      } catch (error) {}
    },
    // 表格操作项点击发布、下架
    handleStatus(row) {
      const { id, name, title, status } = row
      let t = name
      let o = ['下架', '发布']
      let st = status === 1 ? 2 : 1
      this.$confirm(`确认要${o[status - 1]}${t}吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const { code } = await updateTalentServeType({ id, status: st })
          if (code === 0) {
            this.getList()
          }
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.text-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;

  .table {
    margin-top: 20px;
    .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>
